var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"extra-large":"","hide-footer":"","title":"Agendamentos"}},[(_vm.model)?_c('List',{attrs:{"data":{model: _vm.model}},on:{"saved":_vm.load}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }